import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import { getMandatoryFieldsList, updateMandatoryField } from "../../../modules/mandatoryFields/action";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";


class ContractFields extends Component {
  state = {
    headerRows: { fieldDisplayName: "Cell Name", enable: "Required Status" },
    order: "desc",
    orderBy: "id"
  };

  componentDidMount() {
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id){
      this.props.getMandatoryFieldsList("Contract");
    }
  }

  toggle = (fieldName, isChecked) => {
    const { SubFarmId = userFarmDetail().id } = this.props;
    console.log(`${fieldName} and ${isChecked}`);
    const formData = {
      enable: !isChecked,
      entityName: "Contract",
      farmId: userFarmDetail().id || this.props.MainFarmId,
      fieldName: fieldName
    };
    this.props.updateMandatoryField(formData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { headerRows, order, orderBy } = this.state;
    const { mandatoryFieldsList = [], fetchingComplete } = this.props;

    return (
      <div className="ticket-body">
        <div className="flex-display ticket-header">
          <h3 className="mainHeading">Mandatory Cells</h3>
        </div>
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div>
                {fetchingComplete ? (
                  <CreateTable
                    order={order}
                    orderBy={orderBy}
                    headerRows={headerRows}
                    rowData={mandatoryFieldsList.filter(
                      item => item.modifiable === true
                    )}
                    onRequestSort={this.handleRequestSort}
                    isMenuRequired={false}
                    //delete={this.deleteRow}
                    isSortingRequired={false}
                    edit={this.editRow}
                    toggle={this.toggle}
                  />
                ) : (
                  <Loader />
                )}
            </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mandatoryFieldsList: state.mandatoryFieldsReducer.MandatoryFieldsList,
    fetchingComplete: state.mandatoryFieldsReducer.fetchingComplete,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getMandatoryFieldsList, updateMandatoryField },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractFields);



// WEBPACK FOOTER //
// ./src/components/private/MandatoryFields/ContractFields.js